import * as React from 'react';
import { Link } from 'react-router-dom';

import { UitkSelect } from 'uitk-react-select';
import { UitkTextInput } from 'uitk-react-input';

export interface CjParametersProps {
  onTrackingPIDSelectChange(event: any): void;
  selectedTrackingPID: string;
  onSIDChange(event: any): void;
  sidValue: string;
}

export class CjParameters extends React.Component<CjParametersProps> {
  public constructor(props) {
    super(props);
  }

  public render() {
    const { onTrackingPIDSelectChange, onSIDChange, selectedTrackingPID, sidValue } = this.props;

    return (
      <>
        <div className="uitk-grid all-b-margin-three">
          <div className="uitk-cell s-cell-1-1 m-cell-1-4 l-cell-1-4 xl-cell-1-4">
            <UitkTextInput
              id="pid"
              label="Input your PID value"
              name="sid"
              onChange={onTrackingPIDSelectChange}
              placeholder="PID"
              value={selectedTrackingPID}
            />
          </div>
        </div>
        <div className="uitk-grid all-b-margin-three">
          <div className="uitk-cell s-cell-1-1 m-cell-1-4 l-cell-1-4 xl-cell-1-4">
            <UitkTextInput
              id="sid"
              label="Input your SID value"
              name="sid"
              onChange={onSIDChange}
              placeholder="SID"
              value={sidValue}
            />
          </div>
        </div>
      </>
    );
  }
}
